import React from "react";

import "./style/HighlightPopup.css";

const HighlightPopup = ({ highlight }) => {
  return highlight.comment ? (
    <div className="Highlight__popup">{highlight.comment}</div>
  ) : (
    <div className="Highlight__popup">暂无评论</div>
  );
};

export default HighlightPopup;
